import React from "react";
import appConfig from "../../../config/app.config";


const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentPointToRemember = () => {
    return (
        <div >
            <h2 className="text-xl font-bold">10.Point To Remember</h2>
            <div>
                <h3><span className="font-bold">Points to remember while handling the password operations:-</span></h3>
                <p>In case of entering the wrong password 5 times consecutively, your account will be locked for 24 hours. </p>
                <p>In case of account login in into another device, your concurrent session will be logged-out automatically. Only one session of one user account is allowed at a time.</p>
            </div>

        </div>
    )
}

export default ContentPointToRemember;